/**
 * `FileUploadCustomContentSource` exposes an API that the caller can use to retrieve the custom_content section of its
 * call
 */
import api from 'sources/api';
import CrmSyncActions from 'actions/crm/CrmSyncActions';

const FileUploadCustomContentSource = {
  fetchCustomContent: {
    remote(state, id, timezone) {
      const endpoint = `/file/${id}/custom_content?timezone=${encodeURIComponent(timezone)}`;
      return api.get(endpoint);
    },
    loading: CrmSyncActions.fetchCustomContentLoading,
    error: CrmSyncActions.fetchCustomContentError,
    success: CrmSyncActions.fetchCustomContentSuccess,
  },
};

export default FileUploadCustomContentSource;
